import api from "@/libs/axios";
import * as ep from "./endpoints";

export default {
  namespaced: true,
  state: () => ({
    campaigns: [],
    lastCampaign: [],
    loadingCampaigns: false,
    pagination: {},
    processingPayment: false,
    availableMethods: [],
    loadingMethods: [],
  }),
  getters: {
    campaigns(state) {
      return state.campaigns;
    },
    loadingCampaigns(state) {
      return state.loadingCampaigns;
    },

    lastCampaign(state) {
      return state.lastCampaign;
    },
    pagination(state) {
      return state.pagination;
    },
    processingPayment(state) {
      return state.processingPayment;
    },
    availableMethods(state) {
      return state.availableMethods;
    },
    loadingMethods(state) {
      return state.loadingMethods;
    },
  },

  mutations: {
    setCampaigns(state, payload) {
      state.campaigns = payload;
    },

    setLastCampaign(state, payload) {
      state.lastCampaign = payload;
    },
    setPagination(state, payload) {
      state.pagination = payload;
    },
    setProcessingPayment(state, payload) {
      state.processingPayment = payload;
    },
    setAvailabeMethods(state, payload) {
      state.availableMethods = payload;
    },
    setLoadingMethods(state, payload) {
      state.loadingMethods = payload;
    },
  },
  actions: {
    async getLastCampaigns(context, payload) {
      context.state.loadingLastCampaigns = true;
      await api
        .get(ep.campaigns(payload.id, payload.page))
        .then((res) => {
          context.commit("setLastCampaign", res.data.data);
          context.commit("setPagination", res.data.pagination);
          context.state.loadingLastCampaigns = false;
        })
        .catch((err) => {});
    },

    async getAvailablePaymentMethods({ commit }, ngoId) {
      commit("setLoadingMethods", true);
      await api
        .get(ep.AVAILABLE_METHODS(ngoId))
        .then((res) => {
          commit("setAvailabeMethods", res.data.data);
        })
        .catch((err) => {});
      commit("setLoadingMethods", false);
    },

    async getCampaigns(context, payload) {
      context.state.loadingCampaigns = true;
      await api
        .get(ep.campaigns(payload.id, payload.type), {
          params: {
            page: payload.page,
          },
        })
        .then((res) => {
          context.commit("setCampaigns", res.data.data);
          context.commit("setPagination", res.data.pagination);
          context.state.loadingCampaigns = false;
        })
        .catch((err) => {});
    },
    async validatePaymentInfo({ commit }, { methodId, number, amount }) {
      return new Promise(async (resolve, reject) => {
        await api
          .post(ep.INIT_PYMENT, {
            phone_number: number,
            amount,
            payment_method_id: methodId,
          })
          .then((res) => {
            let statusCode = res.status,
              error = statusCode >= 400 && statusCode <= 500;
            if (error) {
              reject({ status: res.status, message: res.data.message });
            } else {
              resolve(res);
            }
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    initFatora({ commit }, { methodId, amount }) {
      commit("setProcessingPayment", true);
      return new Promise(async (resolve, reject) => {
        await api
          .post(ep.INIT_PYMENT, {
            payment_method_id: methodId,
            amount,
          })
          .then((res) => {
            let statusCode = res.status,
              error = statusCode >= 400 && statusCode <= 500;
            if (error) {
              reject(error);
            } else {
              resolve(res);
            }
          })
          .catch((err) => {
            reject(err);
          })
          .finally(() => {
            commit("setProcessingPayment", false);
          });
      });
    },

    async finalizePayment({ commit }, { transactionUUID, methodId, otp }) {
      commit("setProcessingPayment", true);
      return new Promise(async (resolve, reject) => {
        await api
          .post(ep.FINALIZE_PAYMENT, {
            payment_method_id: methodId,
            transaction_id: transactionUUID,
            otp,
          })
          .then((res) => {
            let statusCode = res.status,
              error = statusCode >= 400 && statusCode <= 500;
            if (error) {
              reject(error);
            } else {
              resolve(res);
            }
          })
          .catch((err) => {
            reject(err);
          })
          .finally(() => {
            commit("setProcessingPayment", false);
          });
      });
    },
  },
};
